import React from 'react';

function Slash() {
  return (
    <svg
      width="12px"
      height="19px"
      viewBox="0 0 12 19"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className="svg-icon--forwardSlash"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-60.000000, -80.000000)" fill="#AB2434">
          <g transform="translate(17.000000, 63.000000)">
            <polygon points="55 17 53.2554942 17 43 36 44.861827 36" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Slash;
